module.exports = __webpack_public_path__ + "img/indoor.848bf04f.png";